import { connect } from 'react-redux';
import { updateSessionToken } from 'features/onboarding/state/slice';
import { updateReauthenticateSessionID } from 'actions/reAuthenticate';

const mapStateToProps = (state) => {
    return {
        session: state.session,
        reAuthenticateSessionID: state.reAuthenticate?.reAuthenticateSessionID,
        reauthenticateSessionStatus: state.reAuthenticate?.reauthenticateSessionStatus,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateSessionToken: (token, redirect, source) =>
            dispatch(updateSessionToken({ token, redirect, source })),
        updateReauthenticateSessionID: (sessionID, redirect, source) =>
            dispatch(updateReauthenticateSessionID(sessionID, redirect, source)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
